import {VenueQueries} from '../../api/venue'

export const VenueService = {queries: VenueQueries}
